module.exports = __webpack_public_path__ + "static/img/productimg7.ae867695.png";